module.exports = __webpack_public_path__ + "static/media/use_esim_zhtw5.cf98f6d7.png";